import type { FridgeForm } from '../forms/useFridgeForm'
import type { SensorForm } from '../forms/useSensorForm'
import { gozokiApiWithAuth } from '../gozokiApi'

// Create a sensor
export const createSensor = async (data: SensorForm) => {
  const response = await gozokiApiWithAuth.post('/sensors', data)
  return response
}

// Update a sensor
export const updateSensor = async ({ id, data }: UpdateSensorArgs) => {
  const response = await gozokiApiWithAuth.patch(`/sensors/${id}`, data)
  return response
}

interface UpdateSensorArgs {
  id: number
  data: Partial<SensorForm>
}

// Create a fridge
export const createFridge = async (data: FridgeForm) => {
  const response = await gozokiApiWithAuth.post('/sensors/fridges', data)
  return response
}

// Update a fridge
export const updateFridge = async ({ id, data }: UpdateFridgeArgs) => {
  const response = await gozokiApiWithAuth.patch(`/sensors/fridges/${id}`, data)
  return response
}

interface UpdateFridgeArgs {
  id: number
  data: Partial<FridgeForm>
}

// Delete a sensor (soft delete)
export const deleteSensor = async (id: number) => {
  const response = await gozokiApiWithAuth.delete(`/sensors/${id}`)
  return response
}

// Delete a fridge (soft delete)
export const deleteFridge = async (id: number) => {
  const response = await gozokiApiWithAuth.delete(`/sensors/fridges/${id}`)
  return response
}
